var exports = {
  "_8": "x4c3adb35--5cf134--img",
  "Ew": "x4c3adb35--5cf134--square",
  "n1": "x4c3adb35--5cf134--circle",
};

module.exports = exports;
